import moment from 'moment';
import _ from 'lodash';
import { validatePortfolioTransactions } from './constants';
import CombinedTradeStep from './components/TradeStep/CombinedTradeStep';
import {store} from "../../store";
import {displayErrorSnackBar} from "../../components/SnackbarProvider/actions";

function getValidPortfolios(portfolios, skipEmpty = false, dataService) {
  if (_.isEmpty(portfolios) || _.isNil(portfolios)) {
    return {
      isValid: false,
      validPortfolios: [],
    };
  }

  let isValid = true, validPortfolios = [], hasAnyTransactions = false;
  portfolios.forEach(portfolio => {
    let validatedPortfolioResult = validatePortfolioTransactions.bind(this)(portfolio, dataService)

    if (validatedPortfolioResult.hasTransactions) {
      hasAnyTransactions = true;
    }

    if (isValid) {
      isValid = validatedPortfolioResult.isValid
      if (!isValid && skipEmpty) {
        isValid = !validatedPortfolioResult.hasTransactions
      }
    }
    if (validatedPortfolioResult.isValid) {
      validPortfolios.push(portfolio)
    }
  })

  return {
    isValid,
    hasAnyTransactions,
    validPortfolios
  }
}

const step1 = {
  "uid": "trade-step",
  "name": null,
  "behaviour": ["dynamic"],
  "category": "Handeln Details",
  "custom_classes": {"stepName": "text-left"},
  "step_content": CombinedTradeStep,
  "question": [
    {
      "uid": "transactions",
      "type": "input",
      "question_text": "Gespeichertes Referenzkonto auswählen",
      "custom_classes": {"labelRoot": "bold"},
      "minDepositDate": moment().add(1, 'days'),
      "isValid": function(step, afterChange, dataService) {
        const { isValid, hasAnyTransactions, validPortfolios } = getValidPortfolios.bind(this)(this.answer, true, dataService);

        if (!hasAnyTransactions) {
          store.dispatch(displayErrorSnackBar('Bitte legen Sie mindestens eine Transaktion an, um fortfahren zu können.'));
          return false;
        }

        const isValidStep = isValid && validPortfolios.length;

        if (isValidStep) {
          this.answer = validPortfolios;
        } else {
          this.lastValidationFailedAt = Date.now();
        }

        return isValidStep;
      },
    },
  ],
};

export const combinedTradeStepsData = {
  steps: [
    step1,
  ],
};
